/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Export Options" |
*
* @param {Dialogue_List_Export_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_form_label = /** @type {((inputs?: Dialogue_List_Export_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de exportação")
	return /** @type {LocalizedString} */ ("Export Options")
});